import { SvgIcon } from '@material-ui/core';

export const IconFlag = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M22.814 0H2v22h2v-7h18.814l-4.33-7.5 4.33-7.5zM4 13V2h15.35l-3.176 5.5 3.175 5.5H4z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
